/**
 * Éléments de page qui ne posent pas de question : ils informent ou invitent, sans rien mesurer.
 * Ils échappent donc aux règles propres aux questions, comme l'unicité des indicateurs.
 *
 * Les valeurs sont celles du discriminant `type` renvoyé par l'API.
 */
export enum CONTENT_TYPE {
    TEXT_ZONE = 'TEXT_ZONE',
    PLATFORM_REVIEW = 'PLATFORM_REVIEW',
}
